import { Typography } from "@mui/material";
import ACROSS_LOGO from "@assets/logo/AAlogo.png";
import "./index.scss";

const LoginBranding = () => {
  return (
    <div className="login-branding">
      <div className="brand-logo">
        <img src={ACROSS_LOGO} className="logo-image" alt="login-branding" />

        <Typography variant="h4" className="brand-name">
          Alternate Travel Plan (ATP) Portal
        </Typography>
      </div>

      <Typography variant="body1" className="brand-description">
        ATP Portal is a complete{" "}
        <strong>Partner Sales & Service platform</strong>.
      </Typography>
    </div>
  );
};

export default LoginBranding;
